import { render, staticRenderFns } from "./Hotwater.vue?vue&type=template&id=383acf23&"
import script from "./Hotwater.vue?vue&type=script&lang=js&"
export * from "./Hotwater.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports